import { UUID } from '@/types';
import { TChartType } from '@/features/chart-configuration/apiSlice';
import { useGetAvailableChartTypes } from './useGetAvailableChartTypes';

const DEFAULT_RESULT = {
  metricColumns: null,
  dimensionColumnsCombinations: null,
  prefill: null,
};
export const useGetPossibleMetricsAndDimensionsForChartType = (
  seriesId: Maybe<UUID>,
  chartType: TChartType,
) => {
  const { data, isFetching } = useGetAvailableChartTypes(seriesId);

  if (isFetching || !data) return DEFAULT_RESULT;

  if (!(chartType in data)) return DEFAULT_RESULT;

  return data[chartType]!;
};
